export default __webpack_public_path__ + "static/media/leaf5.9c080d0a.svg";